import { LoggingType, LogTarget } from './types';

export const LoggerConfiguration: Record<string, LoggingType> = {
  Core: {
    type: 'console',
    level: 'error',
  },
  VideoPlayerLogger: {
    type: 'none',
    level: 'info',
  },
};

export const LogTargets: Record<string, LogTarget> = {
  performance: 'server',
  click: 'server',
  errors: 'server',
};
